import type { DocumentId, DocumentRevision } from 'core/types';
import type { BaseDocumentModel } from './BaseDocument.model';

export enum DocumentOperations {
  create = 'create',
  update = 'update',
  delete = 'delete',
}

export class BaseDocumentChangeModel<T = BaseDocumentModel> {
  docId: DocumentId;

  operation: DocumentOperations;

  revision: DocumentRevision;

  userId: DocumentId;

  patch: Partial<T>; // TODO: need to unify models on API side

  change: Partial<T>;

  createdAtUTC: Date;
}
